module.exports = __webpack_public_path__ + "static/media/img_car_3_desktop.0b342f12.webp";